module.exports = __webpack_public_path__ + "static/media/dna-white.1c27dafc.svg";